import type { ReactNode } from 'react';

interface PageLayoutProps {
  title?: string;
  breadcrumb?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

export function PageLayout({ title, breadcrumb, actions, children }: PageLayoutProps) {
  return (
    <div className='flex w-full min-w-[400px] flex-col gap-6 px-4 py-6 sm:px-6 md:px-8'>
      {breadcrumb && <div className='-mb-2'>{breadcrumb}</div>}
      {(title || actions) && (
        <div className='flex items-center justify-between gap-4'>
          {title && <h1 className='text-3xl font-bold text-foreground'>{title}</h1>}
          {actions && <div className='flex items-center gap-2'>{actions}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
